@if (event()) {
  <p-card class="custom-card">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <div class="field-label">Data</div>
        <div class="field-value">
          {{ event()!.eventDate | date: 'yyyy-MM-dd HH:mm:ss' }}
        </div>
      </div>
      <div>
        <div class="field-label">Obiekt</div>
        <div class="field-value">{{ event()!.eventObject }}</div>
      </div>
      <div>
        <div class="field-label">Rodzaj</div>
        <div class="field-value">
          {{ getRodzajZdarzeniaLabel(event()!.eventType) }}
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div>
        <div class="field-label">Autor</div>
        <div class="field-value">{{ event()!.eventAuthor }}</div>
      </div>
    </div>

    <div class="mt-6">
      <div class="field-label">Szczegóły</div>
      <div class="field-value">
        <app-history-event-details [details]="event()!.eventDetails" />
      </div>
    </div>
  </p-card>

  <div class="flex justify-end mt-6">
    <p-button
      label="Zamknij"
      styleClass="customInfoButton outlined"
      (click)="close()"
    />
  </div>
}
